import { useEffect, useState } from 'react';
import { SocketNamespace } from '@trinity/chat';
import type { Socket } from 'socket.io-client';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

export const useProjectSocket = (projectId: number): Socket => {
  const [socket, setSocket] = useState<Socket>();
  const getSocket = useGetSocket(SocketNamespace.Projects);

  useEffect(() => {
    if (projectId) {
      const newSocket = getSocket();

      setSocket(newSocket);

      newSocket.emit('subscribe', projectId);

      return () => {
        newSocket.emit('unsubscribe', projectId);
        newSocket.disconnect();
      };
    }
  }, [getSocket, projectId]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.Projects);

  return socket;
};